import {
  Box,
  Button,
  FileInput,
  Group,
  LoadingOverlay,
  Select,
  TextInput,
  Textarea,
  rem,
} from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconFileCv } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import ImageShow from "../../../_base/component/_image";
import { createMedia, getDataMediaGroup } from "../../../api/ApiMedia";
import { TblMedia, TblMediaGroup } from "../../../model/TblMedia";
import ButtonClose from "../../../common/ButtonClose/ButtonClose";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { formatDateToString } from "../../../_base/helper/FunctionHelper";
import { uploadImageAddFolder } from "../../../api/ApiMore";

const icon = (
  <IconFileCv style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
);

const CreateView = ({ onSearch }: any) => {
  const entity = {
    mediaId: 0,
    mediaName: "",
    mediaCode: "",
    linkFile: "",
    mediaGroup: null,
    mediaGroupId: null,
    mediaWidth: null,
    mediaHeight: null,
    uploadFile: null,
    codeHtml: "",
    creationDate: "",
    createdBy: "",
    lastUpdateDate: "",
    lastUpdatedBy: "",
  };

  const handleCreateMedia = async (dataSubmit: TblMedia) => {
    open();
    await createMedia({
      ...dataSubmit,
      uploadFile: urlImageUpload.length > 0 ? urlImageUpload : null,
    });
    close();
    onSearch();
    modals.closeAll();
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [dataMediaGroup, setDataMediaGroup] = useState<TblMediaGroup[]>([]);
  const [dataOption, setDataOption] = useState<any[]>();
  const [urlImageUpload, setUrlImageUpload] = useState<string>("");
  const [loadingImage, setLoadingImage] = useState<number>(0);

  const form = useForm<TblMedia>({
    initialValues: {
      ...entity,
    },
    validate: {
      mediaName: isNotEmpty("Tên chưa chưa nhập"),
      mediaCode: isNotEmpty("Code chưa chưa nhập"),
      linkFile: isNotEmpty("Link chưa nhập"),
      mediaWidth: isNotEmpty("Chưa nhập chiều rộng media"),
      mediaHeight: isNotEmpty("Chưa nhập chiều cao media"),
      mediaGroup: isNotEmpty("Chưa chọn danh mục media"),
      uploadFile: isNotEmpty("Chưa upload File media"),
      codeHtml: isNotEmpty("Code HTML chưa chưa nhập"),
    },
  });

  const handleChangeDataMediaGroup = (name: string | null) => {
    if (name) {
      const Province = dataMediaGroup?.filter(
        (item: TblMediaGroup) => item.name === name
      );
      form.getInputProps("mediaGroupId").onChange(Province[0].id);
      form.getInputProps("mediaGroup").onChange(Province[0].name);
    }
  };

  const handleUploadImage = async (files: File[] | File) => {
    if (!files) {
      NotificationExtension.Fails("File sai định dạng hoặc không tồn tại !");
      return;
    }

    const newDate = formatDateToString(new Date());
    const fileArray = Array.isArray(files) ? files : [files];

    if (fileArray.length === 0) {
      NotificationExtension.Fails("File sai định dạng hoặc không tồn tại !");
      return;
    } else {
      const res = await uploadImageAddFolder(
        `cdn/Media/Image/Media/${newDate}`,
        fileArray
      );

      if (res && res.success) {
        const data = res?.data[0]?.url;
        NotificationExtension.Success("Tải ảnh lên thành công !");
        setUrlImageUpload(data);
        setLoadingImage((prev) => prev + 1);
      } else {
        NotificationExtension.Fails(res.message);
        setUrlImageUpload("");
        form.setValues((prev) => ({ ...prev, uploadFile: null }));
      }
    }
  };

  useEffect(() => {
    const loadDataMediaGroup = async () => {
      setDataMediaGroup([]);
      const data = await getDataMediaGroup("Active=true&Skip=0&Take=1000");
      if (data?.data) {
        const uniqueData = data.data.filter(
          (item: any, index: number, self: any[]) =>
            index === self.findIndex((t) => t.name === item.name)
        );
        setDataMediaGroup(uniqueData);
      }
    };
    loadDataMediaGroup();
  }, []);

  useEffect(() => {
    if (dataMediaGroup) {
      setDataOption(
        dataMediaGroup.map((option) => {
          return {
            value: option?.name,
            label: option?.name,
          };
        })
      );
    }
  }, [dataMediaGroup]);

  useEffect(() => {
    const fileUpload = form.getValues()?.uploadFile;
    if (fileUpload && fileUpload instanceof File) {
      handleUploadImage(fileUpload);
    }
  }, [form.getValues()?.uploadFile]);

  return (
    <>
      <Box
        className="flex-none"
        component="form"
        miw={900}
        maw={900}
        mx="auto"
        onSubmit={form.onSubmit((e: TblMedia) => {
          handleCreateMedia(e);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Tên media"}
            placeholder={"Nhập tên"}
            withAsterisk
            mt="md"
            type="text"
            {...form.getInputProps("mediaName")}
          />
          <TextInput
            label={"Code media"}
            placeholder={"Nhập code"}
            withAsterisk
            mt="md"
            type="text"
            {...form.getInputProps("mediaCode")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Link file"}
            placeholder={"Nhập link"}
            withAsterisk
            mt="md"
            type="text"
            {...form.getInputProps("linkFile")}
          />
          <Select
            label={"Phân nhóm"}
            placeholder={"Chọn danh mục media"}
            withAsterisk
            mt="md"
            data={dataOption}
            {...form.getInputProps("mediaGroup")}
            onChange={handleChangeDataMediaGroup}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Chiều rộng (width) (px)"}
            placeholder={""}
            mt="md"
            type="number"
            {...form.getInputProps("mediaWidth")}
            withAsterisk
          />
          <TextInput
            label={"Chiều cao (height) (px)"}
            placeholder={""}
            mt="md"
            type="number"
            {...form.getInputProps("mediaHeight")}
            withAsterisk
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <FileInput
            leftSection={icon}
            label={"Upload File"}
            placeholder={"Chọn file"}
            withAsterisk
            clearable
            mt="md"
            leftSectionPointerEvents="none"
            {...form.getInputProps("uploadFile")}
          />
          {urlImageUpload.length > 0 ? (
            <ImageShow
              h={200}
              w={200}
              img={urlImageUpload}
              loading={loadingImage}
            />
          ) : (
            <Box></Box>
          )}
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <Textarea
            label={"Code HTML"}
            placeholder={"Nhập code"}
            withAsterisk
            mt="md"
            {...form.getInputProps("codeHtml")}
          />
        </Group>

        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <ButtonClose />
        </Group>
      </Box>
    </>
  );
};

export default CreateView;
